import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormGroup, TextField } from "@mui/material";
import { useCallback, useEffect, useReducer, useState } from "react";
import api, { UpdateUserProfileDto } from "../../../api";
import { createStateReducer, notif } from "../../utils";
import { RepeatPasswordControl } from "./RepeatPasswordControl";

export interface UserProfileDialogProps {
  open: boolean;
  onClose: () => void;
}

type DialogState = "closed" | "open";

export const UserProfileDialog = (props: UserProfileDialogProps) => {
  const { open, onClose } = props;

  const [dialogState, setDialogState] = useState<DialogState>("closed");
  const reducer = createStateReducer<UpdateUserProfileDto>();
  const [state, dispatch] = useReducer(reducer, null);
  const [passwordValid, setPasswordValid] = useState(true);

  const handleClose = () => {
    setDialogState("closed");
    onClose();
  };

  const handleAccept = async () => {
    try {
      if (!passwordValid) {
        notif("Entered passwords are not equal", "error");
      } else {
        await api.user.update(state as any);
        handleClose();
      }
    } catch (err) {
      notif(err, "error");
    }
  };

  const handlePasswordChange = (value: string, isValid: boolean) => {
    dispatch({ state: { password: value } });
    setPasswordValid(isValid);
  };

  const loadProfile = useCallback(async () => {
    try {
      const profile = await api.user.profile();
      dispatch({ state: profile, replace: true });
      setPasswordValid(true);
      setDialogState("open");
    } catch (err) {
      notif(err, "error");
      handleClose();
    }
  }, []);

  useEffect(() => {
    if (open) {
      loadProfile();
    }
  }, [open, loadProfile]);

  return (
    <Dialog open={dialogState === "open"} onClose={handleClose} maxWidth="sm">
      <DialogTitle>EDIT PROFILE</DialogTitle>
      <DialogContent dividers>
        <FormGroup sx={{ minWidth: 300 }}>
          <TextField label="Email" required variant="standard" value={state?.email ?? ""} onChange={(e) => dispatch({ state: { email: e.target.value } })} />
          <RepeatPasswordControl required={false} onChange={handlePasswordChange} />
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAccept}>Accept</Button>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
